// extracted by mini-css-extract-plugin
export default {"EventsPage":"EventsPage_EventsPage__uC-48","list":"EventsPage_list__wVpN4"};